import React from 'react';
import { NavLink} from 'react-router-dom';


const Header = (props) => {
  return (
  
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <NavLink className="navbar-brand page-scroll" to="/">
            Swaly Forme
          </NavLink>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
       <ul className="nav navbar-nav navbar-right">
        
            <li>
              <NavLink to="/qui_suis_je" className="page-scroll">
                Qui suis-je ?
              </NavLink>
            </li>
            <li>
              <NavLink to="/mes_activites" className="page-scroll">
                Mes activités  
              </NavLink></li>
            <li>
              <NavLink to="/stage" className="page-scroll">
                Stage
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="page-scroll">
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
export default Header;